// Shared display helpers for statuses, risk levels, dates.

export const STATUS_CONFIG = {
  COMPLETED: { label: "Completado", icon: "check", color: "text-emerald-600", bg: "bg-emerald-50", ring: "ring-emerald-200" },
  IN_PROGRESS: { label: "En progreso", icon: "clock", color: "text-amber-500", bg: "bg-amber-50", ring: "ring-amber-200" },
  PENDING: { label: "Pendiente", icon: "alert", color: "text-red-500", bg: "bg-red-50", ring: "ring-red-200" },
  NOT_APPLICABLE: { label: "No aplica", icon: "minus", color: "text-slate-400", bg: "bg-slate-50", ring: "ring-slate-200" },
  REJECTED: { label: "Rechazado", icon: "x", color: "text-red-600", bg: "bg-red-50", ring: "ring-red-200" },
  EXPIRED: { label: "Expirado", icon: "alert", color: "text-orange-600", bg: "bg-orange-50", ring: "ring-orange-200" },
};

export const RISK_CONFIG = {
  LOW: { label: "Bajo", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  MEDIUM: { label: "Medio", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  HIGH: { label: "Alto", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  CRITICAL: { label: "Crítico", cls: "bg-red-900 text-red-50 border-red-900" },
};

export const INTENT_CONFIG = {
  NONE: { label: "Sin respuesta", cls: "bg-slate-100 text-slate-600" },
  CONTINUE: { label: "Quiere continuar", cls: "bg-blue-50 text-blue-700" },
  NEEDS_HELP: { label: "Necesita ayuda", cls: "bg-amber-50 text-amber-700" },
  WITHDRAW: { label: "No continuará", cls: "bg-red-50 text-red-700" },
};

export const TONE_CONFIG = {
  SOFT: { label: "Amigable", desc: "Tono cercano y sin presión" },
  STANDARD: { label: "Recordatorio", desc: "Recordatorio con fecha límite" },
  URGENT: { label: "Atención", desc: "Urgencia moderada, ingreso próximo" },
  FINAL_REMINDER: { label: "Último aviso", desc: "Confirmar interés en continuar" },
};

export const CHANNEL_LABEL = { whatsapp: "WhatsApp", email: "Email", sms: "SMS", manual: "Registro manual" };

export function formatDate(dt) {
  if (!dt) return "—";
  const d = new Date(dt);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("es-CL", { day: "2-digit", month: "short", year: "numeric" });
}

export function relativeDays(dt) {
  if (!dt) return "Sin contacto";
  const d = new Date(dt);
  if (isNaN(d)) return "—";
  const diff = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (diff <= 0) return "Hoy";
  if (diff === 1) return "Ayer";
  return `Hace ${diff} días`;
}
